module.exports = __webpack_public_path__ + "@/assets/img/fotty.282dcdd7.jpg";